import {useCallback} from 'react';
import {Button} from '~library/atoms/Button';
import {Input} from '~library/atoms/Input';
import {TrashIcon} from '~library/svg/v2/TrashIcon';
import {tanzanite} from '~libSass/base/_exports.sass';

export const WtbItems = (props) => {
  const {opt, itemNum, minItems, index, canRemove, itemCallback} = props;
  const inputRequired = itemNum <= minItems;
  const inputTabIndex = 2 + index * 2;

  const handleRemoveItemClick = useCallback(
    (e) => {
      itemCallback(index, e, 'remove');
    },
    [index, itemCallback]
  );

  const handleQuantityChange = useCallback(
    (e) => {
      if (/^\d+$/.test(e.target.value) || e.target.value === '') {
        itemCallback(index, e, 'qtyChange');
      }
    },
    [index, itemCallback]
  );

  return (
    <div className="wtb-item-wrapper">
      <div key={`wtb-create-${itemNum}`} className="wtb__item">
        <Input
          className="wtb__item__input"
          type="text"
          value={opt.name}
          placeholder={opt.placeholder}
          aria-label={opt.placeholder}
          onChange={(e) => itemCallback(index, e, 'nameChange')}
          maxLength={140}
          required={inputRequired}
          tabIndex={inputTabIndex}
          autoFocus={false}
          data-qa-id={`wtb-item-${index}`}
        />

        <Input
          className="wtb__qty__input"
          type="text"
          value={opt.quantity}
          onChange={handleQuantityChange}
          maxLength={3}
          min={1}
          max={999}
          required={inputRequired}
          tabIndex={inputTabIndex}
          autoFocus={false}
          data-qa-id={`wtb-item-quantity-${index}`}
        />

        {canRemove && (
          <Button
            className="wtb__delete-button"
            variant="transparent"
            data-qa-id={`delete-item-${inputTabIndex + 1}`}
            type="button"
            onClick={handleRemoveItemClick}
            disabled={opt.response_count > 0 ? 'disabled' : false}
            ariaLabel="Remove item"
          >
            <TrashIcon ratio={0.5} color={tanzanite} />
          </Button>
        )}
      </div>
    </div>
  );
};
